var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#45728B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.907 6.77101L10.0151 12.6629C9.42837 13.2496 7.68672 13.5214 7.29763 13.1323C6.90854 12.7432 7.17411 11.0016 7.76083 10.4148L13.659 4.51674C13.8044 4.35806 13.9805 4.2305 14.1766 4.14175C14.3727 4.053 14.5848 4.00489 14.8 4.00035C15.0152 3.99583 15.2291 4.03494 15.4288 4.11536C15.6285 4.19578 15.8098 4.31584 15.9618 4.46827C16.1138 4.62069 16.2334 4.80233 16.3132 5.00222C16.3931 5.20212 16.4317 5.41612 16.4266 5.63132C16.4214 5.84653 16.3727 6.05848 16.2835 6.25435C16.1941 6.45023 16.0661 6.62599 15.907 6.77101Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55842 5.28882H6.47041C5.81521 5.28882 5.1869 5.54909 4.7236 6.01238C4.26031 6.47568 4 7.10403 4 7.75923V13.9353C4 14.5905 4.26031 15.2188 4.7236 15.6821C5.1869 16.1454 5.81521 16.4057 6.47041 16.4057H13.264C14.6289 16.4057 15.1168 15.294 15.1168 13.9353V10.8472",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.06fd694abf96e87473a586e29ad28760.svg";
export { ForwardRef as ReactComponent };